<div class="row mb-2 mr-0 pl-3 pb-0"  *ngIf="global.docbool">
    <div class="col ml-1">
        <div widget class="card border-0 box-shadow">
                <div class="row">
                    <div class="col b-col">
                        <div class="b1">
                            <h4 class="mb-0 font-header">Client</h4>
                        </div>
                        <div class="b2">
                            <button class="btn btn-sm px-3" *ngIf="clientonboardBO.edit"
                            data-bs-toggle="modal" data-bs-target="#closemodal"><i
                                    class=" fa fa-arrow-left mr-1"></i>Close</button>
                        </div>
                    </div>
                </div>   
        </div>
    </div>
</div>

<span id="cancelmodal" data-bs-toggle="modal" data-bs-target="#closemodal"></span>
<div class="modal hide fade modalbackgrod" id="closemodal" tabindex="-1" aria-labelledby="exampleModalLabel"
aria-hidden="true"  data-bs-backdrop="false">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Close Alert</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <label>You want to close without save?</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" data-bs-dismiss="modal" (click)="backToClientOnboardingList()">Yes & Close</button>
        <button type="button" class="btn btn-sm ms-2" id="closedeletemodal" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>


<app-files  *ngIf="global.docbool" (saveAllEvent)="onSaveCompleted($event)"
    [clientonboardBO]="clientonboardBO"></app-files>



